export class DialogTypes {
  static XSmall: DialogType = 'mw-dialog-x-small';
  static Small: DialogType = 'mw-dialog-small';
  static Medium: DialogType = 'mw-dialog-medium';
  static Large: DialogType = 'mw-dialog-large';
  static XLarge: DialogType = 'mw-dialog-x-large';
  static FullScreen: DialogType = 'mw-dialog-full-screen';
}

export type DialogType =
  | 'mw-dialog-x-small'
  | 'mw-dialog-small'
  | 'mw-dialog-medium'
  | 'mw-dialog-large'
  | 'mw-dialog-x-large'
  | 'mw-dialog-full-screen';
